var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled, { css } from 'styled-components';
import { Icon as BaseIcon } from '../Icon';
import { Text } from '../Text';
var handleBadgeColor = function (variant, theme) {
  switch (variant) {
    case 'positive':
      return theme.tokens.interface.feedback.positive.lightest;
    case 'neutral':
      return theme.tokens.interface.neutral.lightest;
    case 'negative':
      return theme.tokens.interface.feedback.negative.lightest;
    case 'tip':
      return theme.tokens.interface.feedback.tip.lightest;
    case 'warning':
      return theme.tokens.interface.feedback.warning.lightest;
    case 'esg':
      return theme.tokens.feature.esg.light;
    case 'share-investing':
      return theme.tokens.feature.primary.lightest;
    case 'info':
    default:
      return theme.tokens.interface.feedback.info.lightest;
  }
};
var handleIconColor = function (variant, theme) {
  switch (variant) {
    case 'positive':
      return theme.tokens.interface.feedback.positive.strong;
    case 'neutral':
      return theme.tokens.interface.neutral.strong;
    case 'negative':
      return theme.tokens.interface.feedback.negative.strong;
    case 'tip':
      return theme.tokens.interface.feedback.tip.strong;
    case 'warning':
      return theme.tokens.interface.feedback.warning.strong;
    case 'esg':
      return theme.tokens.feature.esg.strong;
    case 'info':
    default:
      return theme.tokens.interface.feedback.info.strong;
  }
};
export var BadgeWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2em 0.5em;\n  background: ", ";\n  border-radius: ", ";\n\n  > svg {\n    margin-right: 4px;\n  }\n"], ["\n  width: fit-content;\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2em 0.5em;\n  background: ", ";\n  border-radius: ", ";\n\n  > svg {\n    margin-right: 4px;\n  }\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return handleBadgeColor(variant, theme);
}, function (_a) {
  var rounded = _a.rounded;
  return rounded ? '4px' : 0;
});
export var Icon = styled(BaseIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return handleIconColor(variant, theme);
});
var getCustomTextColorCss = function (theme, badgeVariant) {
  switch (badgeVariant) {
    case 'esg':
      return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.tokens.feature.esg.strong);
    case 'share-investing':
      return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.tokens.feature.primary.regular);
    case 'positive':
    case 'neutral':
    case 'negative':
    case 'tip':
    case 'warning':
    case 'info':
      return '';
  }
};
export var StyledText = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var badgeVariant = _a.badgeVariant,
    theme = _a.theme;
  return getCustomTextColorCss(theme, badgeVariant);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;